import { useState } from "react";
import { usePanel } from "./usePanel";

const FALLBACK = "/InstaGain.png";

/**
 * The account's photo, wherever it is shown.
 *
 * Instagram's picture addresses expire: when one no longer loads the panel's own logo takes
 * its place instead of a broken image. The old panel did this by walking the DOM after
 * every refresh.
 */
export function ProfileImage({ alt, className = "cs-profile-image" }: { alt: string; className?: string }) {
  const { profile } = usePanel();
  const source = profile?.profilePictureUrl || FALLBACK;
  const [failed, setFailed] = useState<string | null>(null);

  return (
    <img
      className={className}
      src={failed === source ? FALLBACK : source}
      alt={alt}
      onError={() => setFailed(source)}
    />
  );
}
